import React from "react";

const Work1 = () => {
  return (
    <div>
      <h3>
        Things I Love the most:
        <br /> <br />
        <span>
          [<span className="love">UI</span>,{" "}
          <span className="love">JavaScript</span>,{" "}
          <span className="love">React.js</span>,{" "}
          <span className="love">FrontEnd</span>,{" "}
          <span className="love">Responsive Design</span>];
        </span>
      </h3>
    </div>
  );
};

export default Work1;
